import SignupUser from '../entity/signupUser';

const SET_USER = 'signup#setUser';
const DISPOSE = 'signup#dispose';

export type State = {
  user: SignupUser | null;
};

type Action = {
  type: typeof SET_USER
    | typeof DISPOSE;
  payload?: SignupUser
    | null;
};

export const initialState = {
  user: null,
};

const signup = (previousState: State = initialState, { type, payload }: Action): State => {
  if (type === SET_USER) {
    return {
      ...previousState,
      user: payload as SignupUser
    };
  }

  if (type === DISPOSE) {
    return initialState;
  }

  return previousState;
};

export const setUser = (user: SignupUser): Action => ({
  type: SET_USER,
  payload: user,
});

export const dispose = (): Action => ({ type: DISPOSE });

export default signup;
